import React, { useState, useEffect, useCallback } from "react";
import './../Maintenance/Maintenance.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PhilhealthNew({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Employer Share",
        "Employee Share",
        "Premium Rate",
        "",
    ]
    var accessor = [
        "id",
        "employer",
        "employee",
        "percentage",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [philhealth, setPhilhealth] = useState([]);
      // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("----Select filter----");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [employer, setEmployer] = useState("");
    const [employee, setEmployee] = useState("");
    const [percentage, setPercentage] = useState("");
     // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editEmployer, setEditEmployer] = useState("");
    const [editEmployee, setEditEmployee] = useState("");
    const [editPercentage, setEditPercentage] = useState("");
    //old
    const [oldEditEmployer, setOldEditEmployer] = useState("");
    const [oldEditEmployee, setOldEditEmployee] = useState("");
    const [oldEditPercentage, setOldEditPercentage] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/PhilhealthNew";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setPhilhealth(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("----Select filter----")
                break;
            case 1:
                setSearchPlaceholder("Search by philhealth id")
                break;
            default:
                setSearchPlaceholder("----Select filter----")
                break;
        }
    }, [fetchData, filterDataIndex]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                return;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setPhilhealth(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employer: employer,
            employee: employee,
            percentage: percentage
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Philhealth", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployer("");
            setEmployee("");
            setPercentage("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employer: editEmployer,
            employee: editEmployee,
            percentage: editPercentage
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.employer !== oldEditEmployer){
                auditInfo.push({
                    setupArea: "Philhealth",
                    actionTaken: "update",
                    field: "Employer",
                    newValue: `${data.employer}`,
                    oldValue: `${oldEditEmployer}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.employee !== oldEditEmployee){
                auditInfo.push({
                    setupArea: "Philhealth",
                    actionTaken: "update",
                    field: "Employee",
                    newValue: `${data.employee}`,
                    oldValue: `${oldEditEmployee}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.percentage !== oldEditPercentage){
                auditInfo.push({
                    setupArea: "Philhealth",
                    actionTaken: "update",
                    field: "Percentage",
                    newValue: `${data.percentage}`,
                    oldValue: `${oldEditPercentage}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditEmployer("");
            setEditEmployee("");
            setEditPercentage("");
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditEmployer(data.employer);
        setEditEmployee(data.employee);
        setEditPercentage(data.percentage);

        setOldEditEmployer(data.employer);
        setOldEditEmployee(data.employee);
        setOldEditPercentage(data.percentage);

        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo shadow-xl">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Government Premiums >"} </span>
                                    <span style={{borderBottom:"1px solid black"}}>{"Philhealth"}</span>
                            </div>
                            <h3>Philhealth</h3>
                        </div>
                        <div className="mainte-body">
                            <div style={{display: "none"}}>
                                {Filter(setFilterDataIndex)}
                                <div className="mainte-body-top row">
                                    {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e)=>handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
                                    <div className="mainte-addBtn row" style={{display: "none"}}>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                    </div>
                                </div>
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={philhealth}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employer={employer}
                    employee={employee}
                    percentage={percentage}
                    setEmployer={setEmployer}
                    setEmployee={setEmployee}
                    setPercentage={setPercentage}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editEmployer={editEmployer}
                    editEmployee={editEmployee}
                    editPercentage={editPercentage}
                    setEditEmployer={setEditEmployer}
                    setEditEmployee={setEditEmployee}
                    setEditPercentage={setEditPercentage}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function AddForm({isOpen, 
    onClose,
    employer,
    employee,
    percentage,
    setEmployer,
    setEmployee,
    setPercentage, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employer 
            || !employee
            || !percentage
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        handleSubmit(e);
    };

    const handleClose = () => {
        onClose();
        setEmployer("");
        setEmployee("");
        setPercentage("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Philhealth</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employer</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="employer"
                                placeholder="Employer"
                                value={employer}
                                onChange={(e) => setEmployer(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !employer && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="employee"
                                placeholder="Employee"
                                value={employee}
                                onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !employee && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Percentage</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="percentage"
                                placeholder="Percentage"
                                value={percentage}
                                onChange={(e) => setPercentage(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !percentage && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose,  
    editEmployer,
    editEmployee,
    editPercentage,
    setEditEmployer,
    setEditEmployee,
    setEditPercentage, 
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(editEmployer === ""
            || editEmployee === ""
            || editPercentage === ""
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        handleUpdate(e);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Philhealth</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employer</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="editEmployer"
                                placeholder="Employer"
                                value={editEmployer}
                                onChange={(e) => setEditEmployer(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: editEmployer === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="editEmployee"
                                placeholder="Employee"
                                value={editEmployee}
                                onChange={(e) => setEditEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: editEmployee === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Percentage</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="editPercentage"
                                placeholder="Percentage"
                                value={editPercentage}
                                onChange={(e) => setEditPercentage(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: editPercentage === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "PhilhealthId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="PhilhealthId">Philhealth Id</option>
            </select>
        </div>
    );
};
export default PhilhealthNew
